import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { BACKEND_BASE_URI } from '../utils/constants';
import { getAuthToken, clearAuthData } from '../utils/localStorage';

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: BACKEND_BASE_URI,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach auth token
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear auth data and redirect to login
      clearAuthData();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
